"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiSlider = getMuiSlider;
function getMuiSlider(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required',
      size: 'small',
      valueLabelDisplay: 'auto'
    },
    styleOverrides: {
      rail: {
        color: palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
        height: 3,
        opacity: palette.mode === 'dark' ? undefined : 1
      },
      track: {
        height: 3
      }
    }
  };
}